// Angular
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/index';
import { Product } from '../../models/b2b/product';
import { addHostDomain, Base64, isEmptyObject } from '../../lib/helpers/utils';

// Service
import { SoledadUserService } from './user.service';

declare var wts: any;
declare var gtag: Function;

@Injectable()
export class WebtrekkService {
    store: AppState = null;
    customerId: string;

    constructor(private store$: Store<AppState>, private soledadUserService: SoledadUserService) {
        this.store$
            .select((state) => state)
            .subscribe((store) => {
                this.store = store;
            });
    }

    getCustomerId(): any {
        return this.soledadUserService.getUserMd5();
    }

    getUserPromos(): string {
        const userpromos = sessionStorage.getItem('userpromos') || '';
        return Base64.decode(userpromos);
    }

    registerPageMain(pageName: string, sec: string) {
        let level1: string = 'Home';
        let level2: string;
        let level3: string;
        let level4: string;

        switch (pageName) {
            case '/dashboard/main':
                level2 = sec;
                level3 = 'Home';
                level4 = 'Home';
                break;

            default:
                level2 = sec;
                level3 = 'Search';
                level4 = 'Search';
                break;
        }

        setTimeout(() => {
            // console.log(addHostDomain(pageName), pageName);
            // console.log("url: ", addHostDomain(this.store.router.state.url));
            const obj = {
                customerId: this.getCustomerId(),
                contentId: addHostDomain(pageName),
                urmCategory: {
                    15: this.getUserPromos(),
                },
                // contentId: addHostDomain(this.store.router.state.url),

                customParameter: {
                    1: addHostDomain(pageName),
                },

                contentGroup: {
                    1: 'B2B',
                    2: level1,
                    3: level2,
                    4: level3,
                    5: level4,
                },
            };

            // wts.push(['send', 'page', obj]);

            gtag('config', 'UA-24096614-1', {
                page_title: 'Home',
                page_path: pageName,
            });
        }, 1000);
    }

    registerResultSearch(data: any) {
        // console.log("store", this.store);
        // console.log("url", this.store.router.state.url);
        // console.log("sec", this.store.search.params.sec);
        // console.log("registerResultSearch: ", data);
        // console.log("info: ", data.total);
        setTimeout(() => {
            const customParameter = {
                1: addHostDomain(this.store.router.state.url + '/results'),
                2: data.params.indiceCarga,
                3: data.params.codigoVelocidad,
                4: data.params.marcasName,
                5: data.params.gama ? Base64.decode(data.params.gama) : '-',
                6: data.params.posicion ? Base64.decode(data.params.posicion) : '-',
                7: data.params.uso ? Base64.decode(data.params.uso) : '-', // uso&tipovehiculo
                8: data.params.estructura ? Base64.decode(data.params.estructura) : '-',
                9: data.params.homologaciones ? Base64.decode(data.params.homologaciones) : '-',
                10: isEmptyObject(data.params.busqueda2) ? '-' : data.params.busqueda2, // medida2
                11: isEmptyObject(data.params.indiceCarga2) ? '-' : data.params.indiceCarga2,
                12: isEmptyObject(data.params.codigoVelocidad2) ? '-' : data.params.codigoVelocidad2,
            };
            const contentGroup = {
                1: 'B2B',
                2: 'Home',
                3: this.store.search.params.sec,
                4: 'Results',
                5: 'Results',
            };
            const internalSearch = data.params.busqueda; // medida
            const numberSearchResults = data.total.toString();
            const searchObj = {
                customerId: this.getCustomerId(),
                contentId: addHostDomain(this.store.router.state.url + '/results'),
                urmCategory: {
                    15: this.getUserPromos(),
                },
                internalSearch,
                numberSearchResults,
                customParameter,
                contentGroup,
            };

            // console.log({searchObj});

            // wts.push(['send', 'page', searchObj]);

            gtag('config', 'UA-24096614-1', {
                page_title: 'busqueda',
                page_path: '/dashboard/products/' + data.params.sec + '?medida=' + data.params.busqueda,
            });
        }, 1000);
    }

    registerViewProduct(product: Product) {
        // console.log("store", this.store);
        // console.log("url", this.store.router.state.url);
        // console.log("sec", this.store.search.params.sec);
        // console.log("registerViewProduct", product);
        // console.log("ID: ", product.info.codigo);

        // this.store.cart.id

        setTimeout(() => {
            // console.log("URL:: ", addHostDomain('/dashboard/products/main') + '/' + product.info.codigo);
            // console.log("URL:: ", '/dashboard/products/main/' + product.info.codigo);
            // console.log("URL: ", addHostDomain(this.store.router.state.url) + '/' + product.info.codigo);
            // wts.push(['send', 'page', {
            //     customerId: this.getCustomerId(),
            //     urmCategory: {
            //         15: this.getUserPromos(),
            //     },
            //     // contentId: addHostDomain(this.store.router.state.url) + '/' + product.info.codigo,
            //     contentId: addHostDomain('/dashboard/products/main') + '/' + product.info.codigo,
            //     // orderValue: this.store.cart.cart.total,
            //     // orderId: this.store.cart.id,
            //     product: product.info.codigo,
            //     productCost: product.rates.base.precioMostrarBusqueda,
            //     // currency: 'EUR',
            //     // productQuantity: '-',
            //     productStatus: 'view',

            //     productCategory: {
            //         // 1: product.info.xxxxx, // Tipo producto
            //         2: product.info.marca,
            //         3: product.info.tipo,
            //     },

            //     customEcommerceParameter: {
            //         1: product.info.ancho,
            //         2: product.info.perfil,
            //         3: product.info.llanta,
            //         4: product.info.carga,
            //         5: product.info.velocidad,
            //         6: product.info.modelo,
            //         7: (product.info.verano) ? 'summer' : (product.info.invierno) ? 'winter' : 'all',
            //         8: product.info.runflat,
            //         // 9: product.info.xxxxx, // Primeros equipos
            //         10: product.info.estructura,
            //         11: product.info.codigoMS,
            //         12: product.info.uso,
            //         13: product.info.gama,
            //         // 14: product.info.xxxxx, // Clasificación (premium, quality)
            //         // 15: product.info.xxxxx, // Subtipo
            //         16: product.info.protector

            //     },
            //     contentGroup: {
            //         1: 'B2B',
            //         2: 'Home',
            //         3: this.store.search.params.sec,
            //         4: 'ViewProduct',
            //         5: product.info.codigo
            //     },
            // }]);

            gtag('config', 'UA-24096614-1', {
                page_title: 'ViewProduct',
                page_path: '/dashboard/products/main/' + product.info.codigo,
            });
        }, 1000);
    }

    registerAddCartProduct(data: any) {
        // console.log("store", this.store);
        // console.log("url", this.store.router.state.url);
        // console.log("sec", this.store.search.params.sec);
        // console.log("registerAddCartProduct", data);

        const product = data.item;

        setTimeout(() => {
            // wts.push(['send', 'page', {
            //     customerId: this.getCustomerId(),
            //     urmCategory: {
            //         15: this.getUserPromos(),
            //     },
            //     contentId: addHostDomain(this.store.router.state.url),
            //     // orderValue: this.store.cart.cart.total,
            //     // orderId: this.store.cart.id,
            //     product: product.info.codigo,
            //     productCost: product.rates.base.precioMostrarBusqueda,
            //     currency: 'EUR',
            //     productQuantity: data.quantity,
            //     productStatus: 'add',

            //     productCategory: {
            //         // 1: product.info.xxxxx, // Tipo producto
            //         2: product.info.marca,
            //         3: product.info.tipo,
            //     },

            //     customEcommerceParameter: {
            //         1: product.info.ancho,
            //         2: product.info.perfil,
            //         3: product.info.llanta,
            //         4: product.info.carga,
            //         5: product.info.velocidad,
            //         6: product.info.modelo,
            //         7: (product.info.verano) ? 'summer' : (product.info.invierno) ? 'winter' : 'all',
            //         8: product.info.runflat,
            //         // 9: product.info.xxxxx, // Primeros equipos
            //         10: product.info.estructura,
            //         11: product.info.codigoMS,
            //         12: product.info.uso,
            //         13: product.info.gama,
            //         // 14: product.info.xxxxx, // Clasificación (premium, quality)
            //         // 15: product.info.xxxxx, // Subtipo
            //         16: product.info.protector

            //     },
            //     contentGroup: {
            //         1: 'B2B',
            //         2: 'Home',
            //         3: this.store.search.params.sec,
            //         4: 'AddProduct',
            //         5: product.info.codigo
            //     },
            // }]);

            gtag('event', 'add_to_cart', {
                event_category: 'ecommerce',
                event_label: product.info.codigo,
            });
        }, 1000);
    }

    registerPurchase() {
        // console.log("store", this.store);
        // console.log("url", this.store.router.state.url);
        // console.log("sec", this.store.search.params.sec);
        // console.log("registerPurchase: ", this.store.cart.cart.items.entities);

        let dataProduct: any;
        let product: Product;
        const products: any = this.store.cart.cart.items.entities;

        // for(let key in products) {
        //     dataProduct = products[key];
        //     product = dataProduct.product;
        //     // console.log("product: ", product);

        //     wts.push(['send', 'page', {
        //         customerId: this.getCustomerId(),
        //         urmCategory: {
        //             15: this.getUserPromos(),
        //         },
        //         contentId: addHostDomain(this.store.router.state.url),
        //         orderValue: this.store.cart.cart.total,
        //         orderId: this.store.cart.id,
        //         product: product.info.codigo,
        //         productCost: product.rates.base.precioMostrarBusqueda,
        //         currency: 'EUR',
        //         productQuantity: dataProduct.quantity,
        //         productStatus: 'conf',

        //         productCategory: {
        //             // 1: product.info.xxxxx, // Tipo producto
        //             2: product.info.marca,
        //             3: product.info.tipo,
        //         },

        //         customEcommerceParameter: {
        //             1: product.info.ancho,
        //             2: product.info.perfil,
        //             3: product.info.llanta,
        //             4: product.info.carga,
        //             5: product.info.velocidad,
        //             6: product.info.modelo,
        //             7: (product.info.verano) ? 'summer' : (product.info.invierno) ? 'winter' : 'all',
        //             8: product.info.runflat,
        //             // 9: product.info.xxxxx, // Primeros equipos
        //             10: product.info.estructura,
        //             11: product.info.codigoMS,
        //             12: product.info.uso,
        //             13: product.info.gama,
        //             // 14: product.info.xxxxx, // Clasificación (premium, quality)
        //             // 15: product.info.xxxxx, // Subtipo
        //             16: product.info.protector

        //         },
        //         contentGroup: {
        //             1: 'B2B',
        //             2: 'Home',
        //             3: 'Cart', // this.store.search.params.sec, // aqui que iría
        //             4: 'ConfProduct',
        //             5: product.info.codigo
        //         },
        //     }]);
        // }
    }

    purchase(checkout: any, uuid: string) {
        // console.log(checkout);

        const cartItems = this.extractItemsFromCheckoutItems(checkout.cart);
        const transaction = {
            transaction_id: uuid,
            tax: this.rround(checkout.importeIva),
            value: this.rround(checkout.importeTotal),
            currency: 'EUR',
            shipping: this.rround(checkout.importePortes),
            items: this.extractItemsFromCartItems(cartItems),
        };

        // console.log(transaction);

        gtag('event', 'purchase', transaction);
    }

    manageRegisterPage(url: string): void {
        const urlActions = {
            '/dashboard/change-user-data': {
                cg1: 'Área cliente',
                cg2: 'mi cuenta',
                cg3: 'configuración',
                cg4: undefined,
            },
            '/dashboard/contacto': {
                cg1: 'Contacto',
                cg2: 'contacto',
                cg3: undefined,
                cg4: undefined,
            },
            '/dashboard/deliverynotes': {
                cg1: 'Área cliente',
                cg2: 'consultas',
                cg3: 'albaranes',
                cg4: undefined,
            },
            '/dashboard/downloads': {
                cg1: 'Área cliente',
                cg2: 'zona info',
                cg3: undefined,
                cg4: undefined,
            },
            '/dashboard/invoices/bills': {
                cg1: 'Área cliente',
                cg2: 'consultas',
                cg3: 'facturas',
                cg4: undefined,
            },
            '/dashboard/invoices/expirations': {
                cg1: 'Área cliente',
                cg2: 'consultas',
                cg3: 'vencimientos',
                cg4: 'Expirations',
            },
            '/dashboard/mi-cuenta': {
                cg1: 'Área cliente',
                cg2: 'mi cuenta',
                cg3: undefined,
                cg4: undefined,
            },
            '/dashboard/orders': {
                cg1: 'Área cliente',
                cg2: 'consultas',
                cg3: 'pedidos',
                cg4: undefined,
            },
            '/dashboard/promotions': {
                cg1: 'Área cliente',
                cg2: 'promos',
                cg3: 'promos',
                cg4: undefined,
            },
        };
        if (urlActions[url]) {
            this.registerPage(url, urlActions[url].cg1, urlActions[url].cg2, urlActions[url].cg3, urlActions[url].cg4);
        }
    }

    registerPage(URL: string, cg1?: string, cg2?: string, cg3?: string, cg4?: string) {
        // console.log('registerpage', URL, cg1, cg2, cg3, cg4);

        setTimeout(() => {
            const obj = {
                customerId: this.getCustomerId(),
                urmCategory: {
                    15: this.getUserPromos(),
                },
                contentId: addHostDomain(URL),
                contentGroup: {
                    1: 'B2B',
                    2: cg1,
                    3: cg2,
                    4: cg3,
                    5: cg4,
                },
                customParameter: {
                    1: addHostDomain(URL),
                },
            };

            // console.log({obj});
            // wts.push(['send', 'page', obj]);
            gtag('config', 'UA-24096614-1', {
                page_title: cg4,
                page_path: URL,
            });
        }, 1000);
    }

    registerEvent(ct: string, ck1?: string) {
        // console.log('registerEvent: ', wts, 'ct: ', ct, 'ck1', ck1);
        // console.log('ct: ', ct, 'ck1', ck1);
        // console.log('customerId', this.getCustomerId());
        // console.log('-----------------------');

        setTimeout(() => {
            // wts.push(['send', 'click', {
            //     customerId: this.getCustomerId(),
            //     linkId: ct,
            //     customClickParameter: {
            //         1: ck1
            //     }
            // }]);

            gtag('event', 'click', {
                event_category: ct,
                event_label: ck1,
            });
        }, 1000);
    }

    getEid(): string {
        return typeof wts !== 'undefined' && typeof wts.get !== 'undefined' ? wts.get('eid') : '';
    }

    private rround(value) {
        return Math.round((value + Number.EPSILON) * 100) / 100;
    }

    private extractItemsFromCheckoutItems(cart) {
        const ids = cart.items.ids;
        const items = [];

        ids.map(function (item, index) {
            const linea = cart.items.entities[item];
            if (linea) {
                items.push(linea);
            }
        });

        return items;
    }

    private extractItemsFromCartItems(items) {
        let products = [];
        items.map((item, index) => {
            products.push({
                id: item.product_id,
                name: item.product.info.nombre.trim(),
                brand: item.product.info.marca.trim(),
                category: item.product.info.tipo,
                quantity: item.quantity,
                price: this.rround(item.product.rates.base.precioMostrarBusqueda),
            });
        });

        return products;
    }
}
